import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import UserTableHead from 'pages/groups/UserTableHeader';
import UserShift from 'pages/groups/UserShift';
import { createData } from 'pages/groups/data';
import { tableStyles } from 'pages/groups/style';

const UsersTable = ({ group, groups, onShift }) => {
  const classes = tableStyles();
  let rows = [];
  const groupUsers = group?.Users;

  if (groupUsers?.length) {
    for (let i = 0; i < groupUsers?.length; i++) {
      const user = groupUsers[i];
      rows.push(
        createData(
          user?.Name,
          user?.Email,
          user?.ID,
          group?.Name,
          <UserShift
            groups={groups}
            group={group}
            onShift={(groupName) =>
              onShift({
                userId: user?.ID,
                userEmail: user?.Email,
                groupName,
                oldGroupName: group?.Name,
              })
            }
          />
        )
      );
    }
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {groupUsers?.length ? (
          <TableContainer>
            <Table className={classes.table} size='medium'>
              <UserTableHead classes={classes} rowCount={rows.length} />
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow tabIndex={-1} key={`${row.name}_${i}`}>
                    <TableCell align='center' padding='none'>
                      {row.name}
                    </TableCell>
                    <TableCell align='center' padding='none'>
                      {row.email}
                    </TableCell>
                    <TableCell align='center' padding='none'>
                      {row.userId}
                    </TableCell>
                    <TableCell align='center' padding='none'>
                      {row.groupName}
                    </TableCell>
                    <TableCell align='center' padding='none'>
                      {row.shift}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div>No Data Found</div>
        )}
      </Paper>
    </div>
  );
};

export default UsersTable;
